module.exports = __webpack_public_path__ + "img/ski_sub_title9.96a22ebb.jpg";